import {fetch} from "utils/dataAccess";

export const WmsStatsPeriod = {
    TODAY: 'today',
    WEEK: 'week'
}

export function getWmsStats(inventoryId, period = WmsStatsPeriod.TODAY, timezone = null) {
    const params = new URLSearchParams({period})
    if (timezone) {
        params.set('timezone', timezone)
    }

    return new Promise((resolve, reject) => {
        fetch(`/wms/stats/${inventoryId}?${params.toString()}`)
            .then(response => {
                response.json().then(retrieved => {
                    resolve(retrieved)
                })
            })
            .catch(error => reject(error))
    })
}
